<div class="max-width-lg white-bg">
  <div class="flex flex-row content mt-64 mb-24">
    <div class="flex flex-row pr-12">
      <button (click)="select(MediaCategory.DOCUMENT)"
           [ngClass]="{'selected': selected === MediaCategory.DOCUMENT}"
           class="items-center filter-item link-btn-font mr-16 documents">
        <div>{{ "SERVICE.DOCUMENTATION" | transloco }}</div>
      </button>
      <button (click)="select(MediaCategory.TUTORIAL)"
           [ngClass]="{'selected': selected === MediaCategory.TUTORIAL}"
           class="flex items-center filter-item link-btn-font tutorials">
        <div>{{ "SERVICE.TUTORIALS" | transloco }}</div>
      </button>
    </div>
    <div class="flex flex-row search-container mr-24">
      <input type="text"
             class="hidden-input fw-400 fs-14" (keyup)="search()"
             placeholder="{{'SERVICE.TYPE_SOMETHING' | transloco}}"
             autocomplete="off"
             [(ngModel)]="searchValue">
      <mat-icon svgIcon="search" class="search-color mr-16"></mat-icon>
    </div>
  </div>

  <div *ngIf="selected === MediaCategory.DOCUMENT">
    <ng-conatiner *ngIf="filteredDocuments.length > 0; else noRecordsFound" class="flex flex-row flex-wrap">
      <app-document-card class="card pb-24" *ngFor="let media of filteredDocuments" [media]="media"></app-document-card>
    </ng-conatiner>
  </div>
  <div *ngIf="selected === MediaCategory.TUTORIAL">
    <ng-conatiner *ngIf="filteredTutorials.length > 0; else noRecordsFound" class="flex flex-row flex-wrap">
      <app-tutorial-card class="card pb-24" *ngFor="let media of filteredTutorials" [media]="media"></app-tutorial-card>
    </ng-conatiner>
  </div>
  <ng-template #noRecordsFound>
    <div class="flex flex-row flex-wrap basis-full items-center w-100-percent mt-20 mb-26">
      <mat-icon svgIcon="search" class="mr-8 icon"></mat-icon>
      <div class="mat-headline-6 mt-12">{{ 'INSPIRATION_LOUNGE.LOUNGE.NO_RESULTS_FOUND' | transloco }}</div>
    </div>
  </ng-template>
</div>
